import styled from 'styled-components';
import { H3, Body5 } from '../style-comps/Common.styles';

export const CardContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 30px auto;
  position: relative;
  padding-bottom: 8px;

  &:hover {
    transform: translateY(-5px);
    cursor: pointer;
  }

  @media (max-width: 768px) {
   width:100%;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: 212px;
  object-fit: cover;
`;

export const CardBody = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Subtitle = styled(Body5)`
  margin: 0 0;
  color: #555;
`;

export const SubtitleSpan = styled(Body5)`
  color: #000;
`;

export const Title = styled(H3)`
  height: auto;    
  margin-bottom: 0;
`;



export const CardFooter = styled.div`
  display: flex;
  flex-direction: column; 
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;

export const BookingLinks = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom:4px;
  margin-top:24px;
 
`;

export const BookingLink = styled.a`
  font-size: 12px;
  color: ${(props) => props.platformcolor || "#61CBC9"};
  text-decoration: none;
  border: 1px solid ${(props) => props.platformcolor || "#61CBC9"};
  padding: 4px 8px;
  border-radius: 32px;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${(props) => props.platformcolor || "#61CBC9"};
    color: white;
  }
`;

export const ButtonStyled = styled.button`
  white-space: nowrap;
  font-size: 12px;
  color: white;
  width:100%;
  background-color: #61CBC9;
  text-decoration: none;
  padding: 8px 8px;
  border-radius: 8px;
  border: none;
  transition: background-color 0.2s;
  align-self: flex-end; 
  margin-top: auto; 
  

  &:hover {
    background-color: #51B7B5;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const InfoItem = styled.span`
  font-size: 12px;
  color: #555;
`;
